"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineConfigProvider = exports.MachineConfigContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const ApiMachineRepo_1 = require("../../../modules/machine/infra/ApiMachineRepo");
exports.MachineConfigContext = react_1.default.createContext(null);
const MachineConfigProvider = ({ children }) => {
    const repo = (0, ApiMachineRepo_1.createApiMachineRepo)();
    const value = {
        getMachineConfig: (machineId) => repo.getMachineConfig(machineId),
        updateMachineConfig: (machineId, config) => repo.updateMachineConfig(machineId, config),
        getProductsByMachine: (id) => repo.getProductsByMachine(id),
    };
    return ((0, jsx_runtime_1.jsx)(exports.MachineConfigContext.Provider, { value: value, children: children }));
};
exports.MachineConfigProvider = MachineConfigProvider;
